import React from "react";

const DateIcon = ({ height = 12.816, width = 11.214 }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 11.214 12.816"
      >
        <path
          id="calendar-alt-regular"
          d="M3.7,7.209h-1a.3.3,0,0,1-.3-.3v-1a.3.3,0,0,1,.3-.3h1a.3.3,0,0,1,.3.3v1A.3.3,0,0,1,3.7,7.209Zm2.7-.3v-1a.3.3,0,0,0-.3-.3h-1a.3.3,0,0,0-.3.3v1a.3.3,0,0,0,.3.3h1A.3.3,0,0,0,6.408,6.908Zm2.4,0v-1a.3.3,0,0,0-.3-.3h-1a.3.3,0,0,0-.3.3v1a.3.3,0,0,0,.3.3h1A.3.3,0,0,0,8.811,6.908Zm-2.4,2.4v-1a.3.3,0,0,0-.3-.3h-1a.3.3,0,0,0-.3.3v1a.3.3,0,0,0,.3.3h1A.3.3,0,0,0,6.408,9.311Zm-2.4,0v-1a.3.3,0,0,0-.3-.3h-1a.3.3,0,0,0-.3.3v1a.3.3,0,0,0,.3.3h1A.3.3,0,0,0,4,9.311Zm4.806,0v-1a.3.3,0,0,0-.3-.3h-1a.3.3,0,0,0-.3.3v1a.3.3,0,0,0,.3.3h1A.3.3,0,0,0,8.811,9.311Zm2.4-6.508v8.811a1.2,1.2,0,0,1-1.2,1.2H1.2a1.2,1.2,0,0,1-1.2-1.2V2.8A1.2,1.2,0,0,1,1.2,1.6H2.4V.3A.3.3,0,0,1,2.7,0h1A.3.3,0,0,1,4,.3V1.6h3.2V.3a.3.3,0,0,1,.3-.3h1a.3.3,0,0,1,.3.3V1.6h1.2A1.2,1.2,0,0,1,11.214,2.8Zm-1.2,8.66V4H1.2v7.459a.151.151,0,0,0,.15.15h8.51A.151.151,0,0,0,10.012,11.464Z"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};
export default DateIcon;
